<template>
  <div class="firstpage" style="margin-top: -1px">
    <img
      class="img-4"
      src="/assets/~/media/images/activity/film2505-prod/mob/4.jpg"
      alt=""
    />
    <div class="button-up" @click="play3(1)"
    code-ga="event, PAGEURL, 更多剧照_上卷"
            code-stm="event, PAGEURL, 更多剧照_上卷">

    </div>
    <div class="button-down" @click="play3(2)"
    code-ga="event, PAGEURL, 更多剧照_下卷"
    code-stm="event, PAGEURL, 更多剧照_下卷">

    </div>
    <el-dialog title="" :visible.sync="isShowCover" append-to-body>
        <div class="cover" v-show="isShowCover">
          <i class="el-icon-close el-icon-close-mob" @click="closePop" style="z-index: 9999;"
              code-stm="event, PAGEURL页面, 关闭弹窗"></i>
          <!-- <div class="top-text">
            <div class="tittle">{{title}}</div>
            <div class="ch-text">我的梦想 所向由心</div>
          </div>   -->

          <div class="pop">
              <div class="top-text">
                <!-- <div class="tittle">{{title}}</div> -->
                <div class="ch-text">我的梦想 所向由心</div>
              </div>
              <div class="swiper-container2 swiper-container2-mob" >
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in imgList" :key="index + 'cover'">
                    <img :src="item" alt="">
                    </div>
                </div>
              </div>
              <div class="swiper-pagination swiper-pagination2"></div>
          </div>
      </div>
    </el-dialog>
    <!-- <div class="cover" v-show="isShowCover">
        <i class="el-icon-close el-icon-close-mob" @click="closePop" style="z-index: 9999;"
            code-stm="`event, PAGEURL页面, 关闭弹窗`"></i>

        <div class="pop">
            <div class="top-text">
          <div class="tittle">{{title}}</div>
          <div class="ch-text">我的梦想 所向由心</div>
        </div>
            <div class="swiper-container2 swiper-container2-mob" >
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in imgList" :key="index + 'cover'">
                <img :src="item" alt="">
                </div>
            </div>
            </div>
            <div class="swiper-pagination swiper-pagination2"></div>
        </div>
    </div> -->
    <el-dialog title="" :visible.sync="isShowVideo" append-to-body>
      <div class="cover-video" v-if="isShowVideo">
        <div class="pop">
          <div class="pop-video" v-if="isShowVideo">
            <video
              ref="videoPlayerFull3" id="videoPlayerFull3"
              class="my-video"
              :src="fullVideoUrl"
              :autoplay="true"
              :loop="false"
              :muted="false"
              direction="0"
              controls
              playsinline
            ></video>
          </div>
          <i
            :class="['el-icon-error', 'error-icon', 'cursor-p']"
            @click="colseVideo"
            code-ga="event,PAGEURL, mob视频_关闭弹窗"
            code-stm="event, PAGEURL, mob视频_关闭弹窗"
          ></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Swiper from "./Swiper";
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
import Swiper from "swiper";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
      preText: "https://www.kia.cn",
      isShowCover: false,
      title: "",
      imgList: [
        '/assets/~/media/images/activity/film2505-prod/mob/up/p1.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p2.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p3.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p4.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p5.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p6.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p7.png',
      ],
      picList1: [
        '/assets/~/media/images/activity/film2505-prod/mob/up/p1.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p2.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p3.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p4.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p5.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p6.png',
        '/assets/~/media/images/activity/film2505-prod/mob/up/p7.png',
      ],
      picList2: [
        '/assets/~/media/images/activity/film2505-prod/mob/down/p8.png',
        '/assets/~/media/images/activity/film2505-prod/mob/down/p9.png',
        '/assets/~/media/images/activity/film2505-prod/mob/down/p10.png',
      ],
      isShowVideo: false,
      fullVideoUrl: "",
    };
  },
  // components: { Swiper },
  mounted: function () {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }
    if (getUrlKey("minip")) {
      this.minip = true;
    }
    this.swiper = new Swiper('.swiper-container2', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination2",
          clickable: true,
          type: 'fraction'
        },
        // navigation: {
        //   nextEl: ".swiper-button-next2",
        //   prevEl: ".swiper-button-prev2",
        // },
      });
  },
  methods: {
    play3(type){
      if(type == 1){//上卷
        this.fullVideoUrl = "https://img.kia.cn/media/videos/202506/dadianying-befo-guanwang.mp4"
      }else{//下卷
        this.fullVideoUrl = "https://img.kia.cn/media/videos/202506/dadianying-after-guanwang.mp4"
      }
      this.isShowVideo= true;
      this.$refs.videoPlayerFull3.play();
    },
    colseVideo() {
      this.isShowVideo = false;
      this.$refs.videoPlayerFull3.pause();
    },
    openPop(index){
        this.isShowCover = true;
        // document.body.style.overflow = 'hidden';
        if(index == 1){//上卷
            this.imgList = this.picList1;
            // this.title = "part01";
        }else{
            this.imgList = this.picList2;
            // this.title = "part02";
        }
        // 在弹窗显示后重新初始化Swiper以确保正常工作
        this.$nextTick(() => {
          this.swiper = new Swiper('.swiper-container2', {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
            loop: true,
            loopFillGroupWithBlank: true,
            pagination: {
              el: ".swiper-pagination2",
              clickable: true,
              type: 'fraction'
            },
            // navigation: {
            //   nextEl: ".swiper-button-next2",
            //   prevEl: ".swiper-button-prev2",
            // },
          });
        });
    },
    closePop() {
      this.isShowCover = false;
      this.swiper.destroy(true, true);
      // document.body.style.overflow = 'auto';
    },
    custormAnchor(anchorName) {
      // window.location = "https://www.kia.cn/activity/2022/08/nq5cpay/7yhegE3/index.html#/?utm_source=&utm_soid=&utm_activity=&mz_ca=&mz_sp="
      this.$parent.directToMove(anchorName);
      // // 找到锚点
      // let anchorElement = document.getElementById(anchorName);
      // // 如果对应id的锚点存在，就跳转到锚点
      // if(anchorElement) { anchorElement.scrollIntoView(); }
    },
    clickPlayIcon: function () {
      let swiperIndex = this.$refs.kiaSwiper.swiper.activeIndex;
      let dom;
      switch (swiperIndex) {
        case 0:
          dom = document.querySelector(".thirdpage");
          dom.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          break;
        case 1:
          dom = document.querySelector(".fourpage");
          dom.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-up {
  position: absolute;
  top: calc((470 ) / 375 * 100vw);
  right: calc(36 / 375 * 100vw);
  width: calc(72 / 375 * 100vw);
  height: calc(72 / 375 * 100vw);
}
.button-down {
    position: absolute;
  top: calc((970) / 375 * 100vw);
  right: calc(36 / 375 * 100vw);
  width: calc(72 / 375 * 100vw);
  height: calc(72 / 375 * 100vw);
}
@import "swiper/css/swiper.css";

.firstpage {
  position: relative;
  //height: 100vh;
  //height: calc(1898 / 1920 * 100vw);
  width: 100%;
  user-select: none;
  z-index: 0;


  .img-4 {
    height: calc(1180 / 375 * 100vw);
  }

  img {
    @media (max-width: 767px) {
      margin-bottom: -1px;
    }

    width: 100%;
    // height: auto;
    //height: 100%;
    //object-fit: cover;
  }

  .icons {
    .playicon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
    //   background: url("../../assets/images/play.jpg") no-repeat;
      z-index: 10;
      cursor: pointer;
    }
  }

  .txt-container {
    width: 21%;
    position: absolute;
    left: 12%;
    top: 13%;
    // .btn-container {
    //   display: flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   margin-top: 8%;
    //   a {
    //     width: 48%;
    //   }
    // }
  }

  .city {
    width: 20%;
    position: absolute;
    bottom: 15vh;
    left: 12%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    color: #fff;
  }

  ::v-deep .swiper-pagination-bullet {
    width: 40px;
    height: 2px;
    display: inline-block;
    border-radius: 0;
    background: #fff;
    color: #fff;
    opacity: 1;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background: #000;
  }

  ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 40px;
    left: 30px;
    width: 100%;
    position: absolute;
    color: #fff;
    z-index: 1;
  }

  @media screen and (orientation: portrait) {
    position: relative;
    // height: calc(2350 / 390 * 100vw);
    // height: 2514px;
    width: 100%;
    user-select: none no-repeat;

    .txt-container {
      // margin-top: 5%;
      position: absolute;
      top: 7%;
      left: 50%;
      transform: translateX(-50%);
      width: 70%;
      //   .btn-container {
      //     display: flex;
      //     justify-content: space-between;
      //     width: 100%;
      //     margin-top: 5%;
      //   }
    }

    .city {
      width: 45%;
      position: absolute;
      bottom: 16vh;
      left: 50%;
      transform: translateX(-50%);
    }

    ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: 15vh;
    }
  }
}
.top-text {
      // position: absolute;
      // top: calc(25% + 30 / 375 * 100vw);
      // height: calc(60 / 375 * 100vw);
      width: 100%;
      z-index: 999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: calc(20 / 375 * 100vw);
    }
    .tittle {
      padding-bottom: calc(10 / 375 * 100vw);
        height: calc(26 / 375 * 100vw);
        // font-family:'FZLanTingHeiS-DB-GB';
      font-size: calc(16 / 375 * 100vw);
      line-height: calc(19 / 375 * 100vw);
      text-align: center;
      color: rgba(255, 255, 255, 0.5);
      z-index: 999;
    }
    .ch-text {
        // font-family:'FZLanTingHeiS-DB-GB';
        font-weight: 400;
        font-size: calc(22 / 375 * 100vw);
        line-height: calc(26 / 375 * 100vw);
        height: calc(26 / 375 * 100vw);
        z-index: 999;
        color: #fff;
    }
.cover {


    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 9999;

    .el-icon-close {
      color: #fff;
      font-size: calc(30 / 375 * 100vw);
      cursor: pointer;
      position: absolute;
      z-index: 99;
      right: calc(50% - 15 / 375 * 100vw);
      bottom: calc(130 / 375 * 100vw);

      &-mob {
        // font-size: 20px;
        opacity: 0.5;
        // right: 20px;
        position: absolute;
      z-index: 99;
      }
    }

    .pop {
      position: relative;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100vw;
      padding: 0 calc(28/375*100vw);
    }

    .swiper-container2 {
      width: 70vw;
      height: auto;
      overflow: hidden;

      /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
      /* height: 80%; */
      .swiper-slide {
        background: rgba($color: #000000, $alpha: 0);

        img {
          width: 78%;
          height: auto;
        }

        @media (max-width: 768px) {
          img {
            width: 100%;
          }
        }
      }

      &-mob {

        width: calc(319/375*100vw);

      }
    }

    .swiper-pagination-fraction {
      position: absolute;
      z-index: 999;
      bottom: -40px;
      color: #fff;
    }

    .swiper-button-next,
    .swiper-button-prev {
      background: rgba($color: #000, $alpha: 0);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);

      &::after {
        /* content: none; */
        font-size: 30px;
        font-weight: 400;
        color: #fff;
      }

      &:hover {
        background: rgba($color: #05141F, $alpha: 0);
      }

      &:hover::after {
        color: #fff;
      }
    }

    .swiper-button-prev,
    .swiper-button-next:focus {
      outline: none;
    }

    .swiper-button-next2 {
      right: 0;
      transform: translateY(-25%);
    }

    .swiper-button-prev2 {
      left: 0;
      transform: translateY(-25%);
    }

    @media (max-width: 768px) {
      .swiper-button-next2 {
        width: auto;
        height: auto;
        right: 2%;
        transform: translateY(25%);
      }

      .swiper-button-prev2 {
        width: auto;
        height: auto;
        left: 2%;
        transform: translateY(25%);
      }
    }
  }

  .cover-video {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #000000;
  z-index: 1000;

  // .el-icon-close {
  //   color: #fff;
  //   font-size: 30px;
  //   cursor: pointer;
  //   position: absolute;
  //   z-index: 99;
  //   right: 20px;
  //   top: 50px;
  // }
  .pop {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .pop-video {
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    video {
      width: 100%;
    }
  }

  .error-icon {
    position: absolute;
    left: 88%;
    // transform: translateX(-50%);
    font-size: 30px;
    top: 2%;
    color: #818181;

    &:hover {
      color: #fff;
    }
  }
}
</style>
